// extracted by mini-css-extract-plugin
export default {"text":"Text_text__F921-","nowrap-true":"Text_nowrap-true__IwX8P","active-true":"Text_active-true__D5B6y","active-red-true":"Text_active-red-true__uVE8v"};